import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID! });

    if (location) {
      if (location.pathname.startsWith('/workspaces') || location.pathname.startsWith('/w')) {
        // @ts-ignore
        window.Intercom('update');
      } else {
        // @ts-ignore
        window.Intercom('boot', {
          api_base: 'https://api-iam.intercom.io',
          APP_ID: 'i2i99qtf',
        });
      }
    }
  }, [location]);
};
